import { UserPermissions } from "Infrastructure/Api/permissions";
import { hasPermission } from "Infrastructure/Utilities/Permissions/hasPermission";
import { usePartnerBalanceTable } from "Partner/Components/Tables/Hooks/usePartnerBalanceTable";
import { PartnerCreateBalanceWidget } from "Partner/Widgets/PartnerCreateBalanceWidget";
import { Table } from "Shared/Components/Table";
import { Grid2 } from "@mui/material";
import type { FC } from "react";

type Props = {
	partnerId: number;
};

export const PartnerBalanceTab: FC<Props> = ({ partnerId }) => {
	const tableOptions = usePartnerBalanceTable(partnerId);

	const hasBalanceReadPermission = hasPermission(
		UserPermissions.PartnerBalanceModule.read,
	);

	const hasBalanceCreatePermission = hasPermission(
		UserPermissions.PartnerBalanceModule.create,
	);

	return (
		<Grid2 container spacing={2} sx={{ width: "100%" }}>
			<Grid2 size={{ xs: 12 }}>
				{hasBalanceCreatePermission && (
					<PartnerCreateBalanceWidget partnerId={partnerId} />
				)}
			</Grid2>
			<Grid2 size={{ xs: 12 }}>
				{hasBalanceReadPermission && <Table tableOptions={tableOptions} />}
			</Grid2>
		</Grid2>
	);
};
